import React from 'react';

import { TextField } from '@material-ui/core';
import PropTypes from 'prop-types';

export default function DetalhesConfig({ data }) {
  return (
    <div>
      {Object.entries(data).map(([campo, valor]) => (
        <TextField
          key={campo}
          name={campo}
          label={campo}
          value={String(valor ?? '')}
          variant="outlined"
          size="small"
          margin="dense"
          fullWidth
          disabled
          InputLabelProps={{ shrink: true }}
        />
      ))}
    </div>
  );
}

DetalhesConfig.propTypes = {
  data: PropTypes.objectOf(PropTypes.any),
};

DetalhesConfig.defaultProps = {
  data: {},
};